import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/TeachingBubble/TeachingBubbleUsage.mdx";

import Examples from "../../Docs/Components/TeachingBubble/TeachingBubbleExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Teaching bubble"
            description="The teaching bubble is useful to highlight new features, first-run experiences, and other new or changed areas in the product."
            apiSources={["azure-devops-ui/Components/TeachingBubble/TeachingBubble.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/JVksI0CagqIZT6xeOudVdGF9/Teaching-bubble"}}
            status={{"design":"done","code":"done","docs":"done"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;